module.exports = __webpack_public_path__ + "img/circle-caret-up.ed9fc0eb.svg";